/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { useState, useEffect, RefObject } from 'react';

/**
 *
 * @param ref is a useRef element.
 * @returns true if the element is in viewport.
 */
export default function useOnScreen(
  ref: RefObject<HTMLElement>,
  options?: { root?: Element | Document | null; rootMargin?: string; thresholds?: ReadonlyArray<number> }
) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), options);
    setTimeout(() => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    }, 250);

    return () => {
      observer.disconnect();
    };
  }, [options, ref]);

  return isIntersecting;
}
